/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface UbereatsOauthTokenPost$Params {
  'Active-Tenant-Identifier': string;
  code: string;
  redirectUri?: string;
}

export function ubereatsOauthTokenPost(http: HttpClient, rootUrl: string, params: UbereatsOauthTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, ubereatsOauthTokenPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('code', params.code, {});
    rb.query('redirectUri', params.redirectUri, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

ubereatsOauthTokenPost.PATH = '/ubereats/oauth/token';
